<template>
    <template v-if="teams && teams.data.length > 0">
        <flex-container>
            <flex-container>
                <flex-container :size="5">
                    <text-heading>
                        Lijst van vestigingen
                    </text-heading>
                </flex-container>
                <flex-container :size="5" justify-content="flex-end">
                    <add-team-button />
                </flex-container>
            </flex-container>
            <inline-tabs selected-name="teams">
                <template
                    v-if="hasWinckBranding()"
                    #labels
                >
                    <inline-tab-label name="teams">
                        Vestigingen
                    </inline-tab-label>
                    <inline-tab-label
                        name="brands"
                        @click="$router.push({ name: 'brand-list' })"
                    >
                        {{ $t('domain.brands') }}
                    </inline-tab-label>
                </template>
                <template #panels>
                    <inline-tab-panel name="teams">
                        <card-normal without-padding :with-overflow="false">
                            <team-list :teams="teams.data" />
                        </card-normal>
                        <flex-container justify-content="center">
                            <flex-container :size="3" :padding="Size.xl">
                                <best-place-icon
                                    :style="{ color: getCssColor('default', 'primary') }"
                                />
                            </flex-container>
                        </flex-container>
                    </inline-tab-panel>
                </template>
            </inline-tabs>
        </flex-container>
    </template>

    <template v-else>
        <team-collection-empty-message />
    </template>

    <router-view />
</template>

<script setup lang="ts">
    import BestPlaceIcon from '@/assets/icons/undraw/best_place.svg?component';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import AddTeamButton from '@/company/team/components/AddTeamButton.vue';
    import TeamList from '@/company/team/components/TeamList.vue';
    import TeamCollectionEmptyMessage from '@/company/team/components/TeamCollectionEmptyMessage.vue';
    import { Team } from '@keyvue/one-api-client';
    import useEventBus from '@/services/eventbus/composables/useEventBus';
    import TeamDeletedEvent from '@/company/team/events/TeamDeletedEvent';
    import { ref } from 'vue';
    import {
        CardNormal,
        FlexContainer,
        getCssColor,
        InlineTabLabel,
        InlineTabPanel,
        InlineTabs,
        Size,
        TextHeading,
    } from '@keyvue/one-ui';
    import useAppBranding from '@/services/app-branding/composables/useAppBranding';

    const { client, currentCompany } = useClient();
    const eventBus = useEventBus();
    const { hasWinckBranding } = useAppBranding();

    const teams = ref();

    async function loadTeams() {
        teams.value = await client.getSubResources(currentCompany.value, Team, 'teams');
    }

    await loadTeams();

    eventBus.subscribe(TeamDeletedEvent, loadTeams);
</script>
